import React from 'react'
import PropTypes from 'prop-types'

const ListeEvenement = ({ children, titre, bouton, isOpen, onToggle }) => {
    return (
        <div className="flex flex-col gap-4 p-4 md:p-6 mx-4 my-4 md:mr-4 md:ml-10 md:my-10 bg-[#272727] rounded-lg shadow-lg text-center md:flex-shrink-0">
            <div
                className="flex flex-row justify-between items-center cursor-pointer md:cursor-default"
                onClick={onToggle}
            >
                <h1 className="text-white font-semibold text-2xl mb-2 font-poppins text-center flex-1">{titre}</h1>
                <div className="flex items-center gap-2">
                    <span className="md:hidden text-gray-400 text-lg select-none">{isOpen ? '▲' : '▼'}</span>
                    <div onClick={e => e.stopPropagation()}>{bouton}</div>
                </div>
            </div>
            <div className={`flex flex-col gap-4 overflow-y-auto ${isOpen ? '' : 'hidden md:flex'}`}>
                {children}
            </div>
        </div>
    )
}

ListeEvenement.propTypes = {
    children: PropTypes.node,
    titre: PropTypes.string,
    bouton: PropTypes.element,
    isOpen: PropTypes.bool,
    onToggle: PropTypes.func,
}

ListeEvenement.defaultProps = {
    children: null,
    titre: 'Événements',
    bouton: null,
    isOpen: true,
    onToggle: () => {},
};

export default ListeEvenement;